<template>
  <div>
    <ReviewCategoryFilter
      v-if="$can('filter', 'review-categorys')"
      :loading="loading"
      @searchFilter="searchFilter"
      @filterPage="filterPage"
    />
    <b-card>
      <TitleTable titleTable="Review Categories" iconTable="fas fa-disease" />
      <div class="m-1">
        <ReviewCategoryEdit
          v-if="isEditReviewCategorySidebarActive"
          :is-edit-review-category-sidebar-active.sync="
            isEditReviewCategorySidebarActive
          "
          :itemEdit="itemEdit"
          @editReviewCategorySuccess="editReviewCategorySuccess"
        />
        <ReviewCategoryAdd
          :is-add-new-review-category-sidebar-active.sync="
            isAddNewReviewCategorySidebarActive
          "
          @createReviewCategory="createReviewCategory"
        />
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <treeselect
              v-model="perPage"
              :options="perPageOptions"
              :clearable="true"
              class="w-25"
            />
          </b-col>
          <!-- {{ $t("Search") }} -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <GoBack class="mr-2" />
              <b-button
                v-if="$can('store', 'review-categorys')"
                variant="primary"
                @click="isAddNewReviewCategorySidebarActive = true"
                :disabled="loading"
              >
                <span v-if="!loading" class="text-nowrap"
                  >{{ $t("Add") }} ReviewCategory</span
                >
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        hover
        bordered
        responsive
        primary-key="id"
        class="position-relative"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(review_of_system)="data">
          <div class="text-nowrap">
            <ul class="list-unstyled my-2 facility">
              <li v-for="(item, i) in data.item.review_of_system" :key="i">
                <b-badge variant="primary"
                  ><span class="text-white">{{ item.name }}</span></b-badge
                >
              </li>
            </ul>
          </div>
        </template>
        <template #cell(status)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.status ? $t("Active") : $t("Inactive")
            }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="$can('update', 'review-categorys')"
            variant="outline-primary"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Edit'"
            @click="editReviewCategory(data.item)"
          >
            <i class="fas fa-pen icon-nm"></i>
          </b-button>

          <b-button
            v-if="$can('destroy', 'review-categorys')"
            variant="outline-danger"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Delete'"
            @click="deleteReviewCategory(data.item)"
          >
            <i class="fas fa-trash-alt icon-nm"></i>
          </b-button>
        </template>
      </b-table>
      <PaginationTable
        :dataMeta="dataMeta"
        :totalUsers="totalUsers"
        :perPage="perPage"
        :currentPage="currentPage"
        @page-changed="pageChanged"
      />
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import axiosAC from "@/core/services/apiInsurance/admin/consults/reviewSystemCategories";

import ToastNotification from "@/components/ToastNotification";
import SpinnerLoading from "@/components/SpinnerLoading";
import PaginationTable from "@/components/PaginationTable";
import TitleTable from "@/components/TitleTable.vue";
import GoBack from "@/components/ButtonBack.vue";
import Swal from "sweetalert2";

import ReviewCategoryEdit from "./ReviewCategoryEdit.vue";
import ReviewCategoryAdd from "./ReviewCategoryAdd.vue";
import ReviewCategoryFilter from "./ReviewCategoryFilter.vue";
import { ref } from "@vue/composition-api";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BAvatar,
    BButton,
    ReviewCategoryEdit,
    ReviewCategoryAdd,
    ReviewCategoryFilter,
    ToastNotification,
    SpinnerLoading,
    PaginationTable,
    TitleTable,
    GoBack,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "id",
        // A column that needs custom formatting
        { key: "name", label: "Name", sortable: true },
        { key: "review_of_system", sortable: true },
        { key: "status", label: "Status" },
        // A virtual column made up from two fields
        { key: "actions", label: "Actions" },
      ],
      items: null,
      loading: false,
      isEditReviewCategorySidebarActive: false,
      isAddNewReviewCategorySidebarActive: false,
      itemEdit: null,
      dataMeta: { from: 1, to: 1, of: 1 },
      totalUsers: 0,
      perPage: 10,
      currentPage: {
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100].map((i) => ({
        id: i,
        label: `Show ${i} Entries`,
      })),
      filtro: false,
      reviewCategoryFilter: null,
    };
  },
  mounted() {
    this.getReviewCategory();
  },
  watch: {
    perPage(newVal) {
      if (!this.filtro) {
        this.getReviewCategory();
      } else {
        this.searchFilter(this.reviewCategoryFilter);
      }
    },
  },
  methods: {
    getReviewCategory() {
      axiosAC
        .reviewSystemCategoryList(this.perPage)
        .then(({ data, current_page, total, per_page, ...res }) => {
          this.items = data;
          this.totalUsers = total;
          this.dataMeta.of = total;
          this.dataMeta.from = res.from;
          this.dataMeta.to = res.to;
          this.currentPage.page = current_page;
        });
    },
    editReviewCategory(item) {
      this.isEditReviewCategorySidebarActive = true;
      this.itemEdit = ref(JSON.parse(JSON.stringify(item)));
    },
    editReviewCategorySuccess(value) {
      if (value) {
        this.$refs.toast.success("Type ReviewCategory updated successfully");
      } else {
        this.$refs.toast.error("Error updating type review-category");
      }
      this.isEditReviewCategorySidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    createReviewCategory({ status }) {
      if (status) {
        this.$refs.toast.success("ReviewCategory type added successfully");
      } else {
        this.$refs.toast.danger("ReviewCategory type not added");
      }
      this.isAddNewReviewCategorySidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    deleteReviewCategory(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosAC.reviewSystemCategoryDelete(item.id).then((response) => {
            this.$refs.toast.success(
              "ReviewCategory type has been deleted successfully"
            );
            this.pageChanged(this.currentPage.page);
          });
        }
      });
    },
    pageChanged(page) {
      if (!this.filtro) {
        axiosAC
          .reviewSystemCategoryPagination(this.perPage, page)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      } else {
        axiosAC
          .reviewSystemCategoryFilterPagination(
            this.perPage,
            page,
            this.reviewCategoryFilter
          )
          .then(({ registro: { data, total, current_page, ...res } }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      }
    },
    searchFilter(value) {
      if (this.filtro) {
        this.loading = true;
        this.reviewCategoryFilter = value;
        axiosAC
          .reviewSystemCategoryFilter(this.perPage, value)
          .then(({ registro: { data, total, current_page, ...res } }) => {
            this.loading = false;
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.getReviewCategory();
      }
    },
    filterPage(value) {
      this.filtro = value;
    },
  },
};
</script>

<style></style>
